<template>
  <div class="w-full relative">
    <Container
      wide
      padding="p-0 mb-20 z-30 relative"
    >
      <div class="flex flex-col mdx:hidden pb-6 space-y-6 ">
        <div>
          <CompanyManagementWidgetContainer
            :edit-mode="editMode"
          />
        </div>
        <div>
          <CompanyManagementWidgetContainer
            :edit-mode="editMode"
            source="boardOfDirectors"
          />
        </div>
        <div>
          <HoldersContainer />
        </div>
        <div>
          <InsiderTradesContainer :inside-company="true" />
        </div>
        <div>
          <BuyAndSellWidgetContainer />
        </div>
        <div>
          <StrategyAndVisionWidgetContainer
            :edit-mode="editMode"
            class="w-full"
          />
        </div>
        <div>
          <ReasonsToInvestWidgetContainer
            :edit-mode="editMode"
            class="w-full"
          />
        </div>
        <div>
          <CompanyDocumentWidgetContainer
            :edit-mode="editMode"
          />
        </div>
      </div>
      <div class="hidden mdx:pl-4 mdx:grid mdx:grid-cols-3 mdx:gap-6 ">
        <div class="col-span-2 space-y-6 mb-4 row-span-2">
          <div>
            <CompanyManagementWidgetContainer
              :edit-mode="editMode"
            />
          </div>
          <div>
            <CompanyManagementWidgetContainer
              :edit-mode="editMode"
              source="boardOfDirectors"
            />
          </div>
          <div>
            <HoldersContainer />
          </div>
          <div>
            <InsiderTradesContainer :inside-company="true" />
          </div>
        </div>

        <div class="space-y-6 row-span-1">
          <div>
            <BuyAndSellWidgetContainer />
          </div>
          <div>
            <StrategyAndVisionWidgetContainer
              :edit-mode="editMode"
              class="w-full"
            />
          </div>
          <div>
            <ReasonsToInvestWidgetContainer
              :edit-mode="editMode"
              class="w-full"
            />
          </div>
          <div>
            <CompanyDocumentWidgetContainer
              :edit-mode="editMode"
            />
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>

<!-- <template>
  <div class="w-full">
    <BlocksWidgetContainer
      :id="company.slug_url + '-1'"
      :edit-mode="editMode"
    />
    <EqualHeightRow left>
      <template #left>
        <HoldersContainer />
      </template>
      <template #right>
        <CompanyManagementWidgetContainer
          :edit-mode="editMode"
        />
      </template>
    </EqualHeightRow>

    <InsiderTradesContainer :inside-company="true" />

    <BlocksWidgetContainer
      :id="company.slug_url + '-2'"
      :edit-mode="editMode"
    />
  </div>
</template> -->

<script>
import HoldersContainer from '@/modules/holders'
// import BlocksWidgetContainer from '@/modules/blocksWidget'
import CompanyManagementWidgetContainer from '@/modules/companyManagementWidget'
import InsiderTradesContainer from '@/modules/insiderTrades/'
import ReasonsToInvestWidgetContainer from '@/modules/reasonsToInvestWidget'
import CompanyDocumentWidgetContainer from '@/modules/companyDocumentWidget'
import StrategyAndVisionWidgetContainer from '@/modules/strategyAndVisionWidget'
import BuyAndSellWidgetContainer from '@/modules/buyAndSellWidget'
import { useCompaniesStore } from '../../stores/companies'
import { isMobile } from '@/js/helpers/mobile'

export default {
  name: 'HoldersModule',
  components: {
    CompanyManagementWidgetContainer,
    HoldersContainer,
    InsiderTradesContainer,
    BuyAndSellWidgetContainer,
    StrategyAndVisionWidgetContainer,
    CompanyDocumentWidgetContainer,
    ReasonsToInvestWidgetContainer
    // BlocksWidgetContainer
  },
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const companiesStore = useCompaniesStore()

    return { companiesStore }
  },
  computed: {
    company() {
      return this.companiesStore.selectedCompany
    },
    isMobile () {
      return isMobile()
    }
  },
  created () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  mounted() {
    const chatBox = document.getElementById('hubspot-messages-iframe-container')
    if (chatBox && isMobile()) {
      chatBox.id ='hideHubspot'
    }
  },
  beforeUnmount() {
    const chatBox = document.getElementById('hideHubspot')
    if (chatBox && isMobile() ) {
      chatBox.id = 'hubspot-messages-iframe-container'
    }
  }
}
</script>
